import VariantGroup from "../../../model/VariantGroup";
import ScreenSection from "../barrels/ScreenSection";

import {
    ProjectAIOrganizeResultSuggestionItem,
    ProjectAIOrganizeResultSuggestionNewVariantGroup,
    ProjectAIOrganizeResultSuggestionUpdatedVariantGroup
} from "./ProjectAIOrganizeResult";

export enum ApplyProjectAIOrganizeResponseStatus {
    SUCCESS = "complete",
    FAILURE = "fail",
    PARTIAL = "partial"
}

export default interface ApplyProjectAIOrganizeResponse {
    appliedSuggestions: {
        newSections: {
            id: string;
            name: string;
            description?: string;
            parent?: string;
            order: string;
            items: ProjectAIOrganizeResultSuggestionItem[];
        }[];
        updatedSections: {
            id: string;
            items: ProjectAIOrganizeResultSuggestionItem[];
        }[];
        newVariantGroups: ProjectAIOrganizeResultSuggestionNewVariantGroup[];
        updatedVariantGroups: ProjectAIOrganizeResultSuggestionUpdatedVariantGroup[];
    };
    project: {
        sections?: ScreenSection[];
        variantGroups?: VariantGroup[];
    };
    status: ApplyProjectAIOrganizeResponseStatus;
}
